import { Price } from "../models/Price";
import { PriceCols } from "../shared/Consts";
import React, { useEffect, useState } from "react";
import Utils from "../portlibs/PortUtils";
import PortAccount from "../models/PortAccount";
import { usePath } from "../libs/path/PathProvider";
import { usePriceConfig } from "../dialogs/PriceConfig";
import Prices from "../models/Prices";
import usePortfolio from "../hooks/PortfolioProvider";
import GTable from "../libs/gtable/GTable";
import PortPref from "../portlibs/PortPref";
import PortUtils from "../portlibs/PortUtils";

const getRows = (tickers:string[], filter:RegExp) : Price[] => 
    (tickers.map(ticker => Prices.i.get(ticker))
    .filter(price => {
        if (!price) return false
        else if (!filter) return true;
        else return filter.test(price.id) || (price.name && filter.test(price.name))
    }) as Price[])


const COLS = [PriceCols.ticker, PriceCols.name, PriceCols.sector, PriceCols.date, PriceCols.price, PriceCols.payout, PriceCols.yield, PriceCols.frequency]
export default function ConfigPage(){
    const {query} = usePath();
    const {portfolio} = usePortfolio()
    const openConfig = usePriceConfig()
    const tickers = ["USD",...portfolio.stockTickers];
    const [rows,setRows] = useState<Price[]>(getRows(tickers, PortUtils.getFilter(query).regex))
    const onRefresh = () => setRows(getRows(tickers, PortUtils.getFilter(query).regex))
    useEffect(() => {
        PortAccount.i.on("refresh", onRefresh)
        return () => { PortAccount.i.removeListener("refresh", onRefresh) }
    },[])
    useEffect(() => {onRefresh()},[query])
    const bodyCell = (row:Price, col:string) => row.value(col)
    const label = (col:string) => Utils.label(col)
    const sorter = (col:string,dir:number) => Utils.holdingSorter(col, dir)
    const rowProps = (row:Price) => ({ onClick : () => openConfig(row) })
    return <GTable tableName="configs" cols={COLS} rows={rows} bodyRowProps={rowProps} bodyCell={bodyCell} label={label} sorter={sorter} userPref={PortPref.i}/>
}
